import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { MapsAPILoader } from '@agm/core';
import * as nations from '../../files/countries.json';
import { KeycloakInitOptions } from 'keycloak-js';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

const url = environment.apiType + '://' + environment.redirectUrl;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  geocoder: any;
  countries: any;
  locations: any[] = [];
  showModerator: boolean = false;
  evaluation: boolean = false;
  showLogin: boolean = true;
  showAlert: boolean = true;
  public dataObj: any = [];
  menuOpen = false;
  closeMenuTimeout: any;

  default: KeycloakInitOptions = {
   redirectUri: url
   //redirectUri: 'http://localhost:4200'
  }

  constructor(
    private router: Router,
    private keycloak: KeycloakService,
    public mapsApiLoader: MapsAPILoader,
  ) { }

  ngOnInit() {
    this.keycloak.isLoggedIn().then(res => {
      if (res == true) {
        this.showLogin = false;
      }
      else {
        this.showLogin = true;
      }
    });

    if (this.keycloak.getUserRoles().includes('LAB')) {
      this.evaluation = true;
    }
    else {
      this.evaluation = false;
    }

    this.countries = nations.countries;
  }
  logout() {
    this.keycloak.logout(this.default.redirectUri);
  }

  login() {
    this.keycloak.login(this.default);
  }

  onHome() {
    if (this.router.url === '/') {
      window.location.reload()
    };
  }

  openMenu() {
    this.menuOpen = true;
    clearTimeout(this.closeMenuTimeout);
  }

  startCloseMenuTimer() {
    this.closeMenuTimeout = setTimeout(() => {
      this.menuOpen = false;
    }, 200);
  }

  cancelCloseMenuTimer() {
    clearTimeout(this.closeMenuTimeout);
  }

  onCities() {
    this.router.navigate(['/Cities'])
  }

  onResults() {
    this.router.navigate(['/Fusilli-Results'])
  }

  onCityMonitor() {
    this.router.navigate(['/City-Monitor'])
  }

  onEvaluation() {
    this.router.navigate(['/City-Results'])
  }

  onRunning() {
    this.router.navigate(['/Transformation-Journeys'])
  }

  onMethodology() {
    Swal.fire({
      title: "Do you want to download the FUSILLI Results Methodology?",
      showCancelButton: true,
      confirmButtonText: "Download",
      denyButtonText: `Cancel`
    }).then((result) => {
      if (result.isConfirmed) {
        const fileUrl = 'assets/D1.9_Evaluation Framework.pdf';
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = 'D1.9_Evaluation Framework.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Swal.fire("Downloaded!", "", "success");
      }
    });
  }
}